import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueMoment from 'vue-moment'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Paginate from 'vuejs-paginate'
import BgElement from './components/BgElement.vue'
import VueAgile from 'vue-agile'

// AXIOS FOR TREES API
import axios from 'axios'
import vueNumeralFilterInstaller from 'vue-numeral-filter';

/* eslint-disable */
const isProd = process.env.NODE_ENV == 'production';

Vue.config.productionTip = false

Vue.prototype.$http = axios

Vue.directive('click-outside', {
	bind: function(el, binding, vNode) {
		// Provided expression must evaluate to a function.
		if (typeof binding.value !== 'function') {
			const compName = vNode.context.name
			let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
			if (compName) { warn += `Found in component '${compName}'` }
			console.warn(warn)
		}
		// Define Handler and cache it on the element
		const bubble = binding.modifiers.bubble
		const handler = (e) => {
			if (bubble || (!el.contains(e.target) && el !== e.target)) {
				binding.value(e)
			}
		}
		el.__vueClickOutside__ = handler
		// add Event Listeners
		document.addEventListener('click', handler)
	},
	unbind: function(el, binding) {
		// Remove Event Listeners
		binding;
		document.removeEventListener('click', el.__vueClickOutside__)
		el.__vueClickOutside__ = null
	}
})

Vue.component('bg-wave-element', BgElement)
Vue.component('paginate', Paginate)

Vue.use(VueMoment)
Vue.use(VueAgile)
Vue.use(vueNumeralFilterInstaller);

new Vue({
  created () {
    AOS.init({
			startEvent: 'load',
			easing: 'ease-out-back',
			duration: 800,
			offset: 200,
			once: true,
			anchorPlacement: "center-center"
    })
  },
  router,
  
  render: h => h(App)
}).$mount('#app')
